import { Outlet, useLocation } from "react-router-dom";
import { usePageScroll } from "@/hooks/usePageScroll";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PathSelectorModal } from "@/components/path-selector/PathSelectorModal";

export default function Layout() {
  const { pathname } = useLocation();

  usePageScroll(pathname);

  return (
    <div className="noise-bg relative min-h-screen bg-background">
      <Header />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <PathSelectorModal />
    </div>
  );
}
